export const translations = {
  ko: {
    name: "고준서",
    nickname: "Chato (차토)",
    email: "비즈니스 문의:",
    role: "머신러닝 엔지니어",
    companies: {
      names: ["헤이딜러(PRND 컴퍼니)", "강남언니팀", "라온데이터"],
      years: ["2025.04 ~ 현재", "2024.09 ~ 2025.04", "2021.09 ~ 2024.09"],
    },
    team: "헤이딜러(PRND 컴퍼니)",
    github: "GitHub",
    scholar: "Google Scholar",
    youtube: "YouTube",
    linkedin: "LinkedIn",
    blog: "블로그",
    book: "유튜브 강의 자료",
    education: "성균관대학교 인공지능융합학과 학/석사",
    introduction: "안녕하세요 4년차 머신러닝/인공지능 엔지니어입니다.",
    workDescription:
      "헤이딜러를 운영하는 PRND 컴퍼니에서 머신러닝 엔지니어로 일하고 있습니다. 뉴스레터와 kotoro 서비스를 개발하고 운영하고 있으며, 여러 외부 강의도 진행하고 있습니다.",
    lectures: "외부 강의",
    projects: "대표 프로젝트",
    techLabel: "사용 기술:",
    educationLabel: "학력",
    aboutLabel: "소개",
    careerLabel: "경력",
    lectureName1: "[TeddyNote] 프롬프톤 우승 전략 소개",
    lectureName2: "[Vessl AI] 비용 절감형 LLMOps개선기",
    lectureName3: "[성균관대학교] 머신러닝 개론 특강",
    project1: {
      title: "강남언니팀 ML 플랫폼 구축",
      description:
        "피쳐스토어, 모델 성능 모니터링, 자동 배포 엔진 개발, 모델 로그 모니터링 시스템 구축 등을 통해 머신러닝의 각 컴포넌트가 유기적으로 연결되는 플랫폼을 구축하였습니다.",
      tech: "Python, Kubernetes, Airflow, FastAPI를 활용한 ML 플랫폼 구축",
      techLabel: "사용 기술:",
    },
    project2: {
      title: "음성합성 모델 연구/개발",
      description:
        "음성합성 모델을 연구하고 개발하였으며, 한국어 발음화 알고리즘 개발을 통해 음성합성의 품질을 향상시키는 연구를 수행하였습니다. 카티어스, SBS미디어넷, TV조선, 갤럭시 코퍼레이션 등 다양한 기업에 적용하였습니다.",
      tech: "PyTorch, VITS, KiwiTokenizer를 활용한 음성합성 모델 개발",
      techLabel: "사용 기술:",
    },
    project3: {
      title: "의료 이미지 인공지능 연구 및 개발",
      description:
        "의료 이미지 인공지능 연구 및 개발을 진행하였습니다. SD-OCT 이미지를 활용한 망막질환 예측모델을 개발하여 10편의 SCIE급 저널 개제와 한길안과병원에 솔루션 납품이라는 성과를 얻었습니다.",
      tech: "PyTorch, Computer Vision을 활용한 의료 영상 분석",
      techLabel: "사용 기술:",
    },
    project4: {
      title: "LLM/RAG 연구 개발",
      description:
        "LLM/RAG 연구 개발을 진행하였습니다. 성형코디네이서 서비스, 사투리 언어모델 JEJUMA 언어모델을 개발하였고, 원티드x네이버클라우드 프롬프톤에서 1등을 차지하였습니다.",
      tech: "LLM, RAG, LangChain을 활용한 인공지능 챗봇 개발",
      techLabel: "사용 기술:",
      links: [
        {
          title: "개발한 프로젝트",
          url: "https://cosmetic.kojunseo.link/",
          iconType: "check",
          iconColor: "#20C997",
        },
        {
          title: "관련 기사",
          url: "https://m.ddaily.co.kr/page/view/2024073016092806180",
          iconType: "news",
          iconColor: "#718096",
        },
        {
          title: "Jejuma",
          url: "https://huggingface.co/JEJUMA/JEJUMA-002",
          iconType: "huggingface",
          iconColor: "#FFD21E",
        },
      ],
    },
    portfolio: "포트폴리오",
    portfolioSubject: "세부 포트폴리오 요청",
    portfolioBody:
      "어떤 목적에서 (채용, 프로젝트, 외주, 강의 등) 포트폴리오를 요청하시는지 알려주세요.",
    coffee: "커피챗",
    kotoro: "Kotoro",
    newsletter: "뉴스레터",
    researchPapers: "연구 논문",
    patents: "특허",
    awards: "수상 내역",
    title: "제목",
    author: "저자",
    year: "연도",
    note: "비고",
    papers: [
      {
        title:
          "Anti-VEGF treatment outcome prediction based on optical coherence tomography images in neovascular age-related macular degeneration using a deep neural network",
        author: "1저자",
        year: "2024",
        note: "SCIE",
        url: "https://www.nature.com/articles/s41598-024-79034-6",
      },
      {
        title:
          "Prediction of Neovascular Age-related Macular Degeneration Recurrence using Optical Coherence Tomography Images with a Deep Neural Network",
        author: "2저자",
        year: "2024",
        note: "SCIE",
        url: "https://www.nature.com/articles/s41598-024-56309-6",
      },
      {
        title: "A Stemmer-based Korean Grapheme-to-Phoneme Converter for Speech Synthesis",
        author: "1저자",
        year: "2023",
        note: "우수논문상",
        url: "https://www.dbpia.co.kr/journal/articleDetail?nodeId=NODE11567506",
      },
      {
        title:
          "Developing and Evaluating an Artificial Intelligence-Based Computer-Aided Diagnosis System for Retinal Disease",
        author: "2저자",
        year: "2023",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&citation_for_view=qt7vHIMAAAAJ:eQOLeE2rZwMC",
      },
      {
        title:
          "Developing and Evaluating an AI-Based Computer-Aided Diagnosis System for Retinal Disease: Diagnostic Study for Central Serous Chorioretinopathy",
        author: "2저자",
        year: "2023",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:YsMSGLbcyi4C",
      },
      {
        title:
          "Detecting Macular Disease Based on Optical Coherence Tomography Using a Deep Convolutional Network",
        author: "저자",
        year: "2023",
        note: "SCIE",
        url: "https://www.mdpi.com/2077-0383/12/3/1005",
      },
      {
        title:
          "Classifying neovascular age-related macular degeneration with a deep convolutional neural network based on optical coherence tomography images",
        author: "저자",
        year: "2022",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:Tyk-4Ss8FVUC",
      },
      {
        title:
          "Assessing central serous chorioretinopathy with deep learning and multiple optical coherence tomography images",
        author: "1저자",
        year: "2022",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:zYLM7Y9cAGgC",
      },
      {
        title:
          "Classifying central serous chorioretinopathy subtypes with a deep neural network using optical coherence tomography images: a cross-sectional study",
        author: "2저자",
        year: "2022",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:qjMakFHDy7sC",
      },
      {
        title: "Trafficformer: A Transformer-based Traffic Predictor",
        author: "1저자",
        year: "2022",
        note: "Conference",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:Y0pCki6q_DkC",
      },
      {
        title:
          "Distinguishing retinal angiomatous proliferation from polypoidal choroidal vasculopathy with a deep neural network based on optical coherence tomography",
        author: "2저자",
        year: "2021",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:u5HHmVD_uO8C",
      },
    ],
    patentsList: [
      {
        title: "3D 마커리스 모션 캡처 기반 3D 아바타 생성 장치 및 방법 특허 등록",
        number: "KR102438488B1",
        url: "https://patents.google.com/patent/KR102438488B1",
      },
      {
        title: "인공지능 기반 탈모 관리 장치 및 방법 특허 등록",
        number: "KR102440397B1",
        url: "https://patents.google.com/patent/KR102440397B1",
      },
      {
        title:
          "웹 페이지의 시변화 데이터 예측 방법, 장치, 이를 이용한 웹 관리 시스템, 컴퓨터 판독 가능한 기록 매체 및 컴퓨터 프로그램 특허 등록",
        number: "KR20240011847A",
        url: "https://patents.google.com/patent/KR20240011847A/",
      },
      {
        title: "AI 기반 망막질환 진단보조 서비스 제공 시스템 특허 등록",
        number: "10-2024-0016551",
      },
      {
        title: "음성합성 장치 및 방법 특허 출원",
        number: "10-2023-0102961",
      },
    ],
    awardsList: [
      "2025 한국관광공사 프롬프톤 구현우수상",
      "2024 원티드랩x네이버클라우드 프롬프톤 고품질상",
      "제 54회 한국정보통신학회 추계학술대회 우수논문상 (1저자)",
      "성균관대학교 인공지능융합학과 우수연구상 (2022년 1학기)",
      "성균관대학교 인공지능융합학과 우수연구상 (2022년 2학기)",
      "중소벤처기업사업부 인공지능 챔피언십 장관상 (라온데이터)",
      "중소벤처기업사업부 인공지능 챔피언십 왕중왕전 (라온데이터)",
      "성균관대학교 2022 대학원 학생성공공모전 선정",
    ],
  },
  en: {
    name: "Junseo Ko",
    nickname: "Chato Ko",
    email: "Business Inquiry:",
    role: "Machine Learning Engineer",
    companies: {
      names: ["Heydealer (PRND Company)", "Gangnam Unni Team", "RaonData"],
      years: ["2025.04 ~ Present", "2024.09 ~ 2025.04", "2021.09 ~ 2024.09"],
    },
    team: "Heydealer",
    educationLabel: "Education",
    aboutLabel: "About",
    careerLabel: "Work",
    github: "GitHub",
    scholar: "Google Scholar",
    youtube: "YouTube",
    linkedin: "LinkedIn",
    blog: "Blog",
    book: "Lecture Notes",
    education: "BS/MS in Artificial Intelligence, SKKU",
    introduction: "Hello, I'm a Machine Learning/AI engineer with 4 years of experience.",
    workDescription:
      "I'm working as a Machine Learning Engineer at PRND Company. I'm also developing and operating newsletter and kotoro services.",
    lectures: "External Lectures",
    projects: "Featured Projects",
    techLabel: "Technologies:",
    lectureName1: "[TeddyNote] Introduction to Prompthon Winning Strategy",
    lectureName2: "[Vessl AI] Cost-Saving LLMOps Improvement",
    lectureName3: "[SKKU] Introduction to Machine Learning",
    project1: {
      title: "ML Platform Development at GangnamUnni",
      description:
        "Built an integrated machine learning platform incorporating feature store, model performance monitoring, automated deployment engine, and model log monitoring systems.",
      tech: "ML Platform development using Python, Kubernetes, Airflow, FastAPI",
      techLabel: "Technologies:",
    },
    project2: {
      title: "Speech Synthesis Research & Development",
      description:
        "Researched and developed speech synthesis models, improving quality through Korean pronunciation algorithms. Successfully implemented for various companies including Cartiers, SBS Medianet, TV Chosun, and Galaxy Corporation.",
      tech: "Speech synthesis model development using PyTorch, VITS, KiwiTokenizer",
      techLabel: "Technologies:",
    },
    project3: {
      title: "Medical Image AI Research & Development",
      description:
        "Conducted medical image AI research and development. Developed retinal disease prediction models using SD-OCT images, resulting in 9 SCIE journal publications and solution delivery to Hangil Eye Hospital.",
      tech: "Medical image analysis using PyTorch and Computer Vision",
      techLabel: "Technologies:",
    },
    project4: {
      title: "LLM/RAG Research & Development",
      description:
        "Conducted LLM/RAG research and development. Developed a plastic surgery coordinator service and JEJUMA dialect language model, winning first place in the Wanted x Naver Cloud Prompthon competition.",
      tech: "AI chatbot development using LLM, RAG, LangChain",
      techLabel: "Technologies:",
      links: [
        {
          title: "Developed Project",
          url: "https://cosmetic.kojunseo.link/",
          iconType: "check",
          iconColor: "#20C997",
        },
        {
          title: "Related News",
          url: "https://m.ddaily.co.kr/page/view/2024073016092806180",
          iconType: "news",
          iconColor: "#718096",
        },
        {
          title: "Jejuma",
          url: "https://huggingface.co/JEJUMA/JEJUMA-002",
          iconType: "huggingface",
          iconColor: "#FFD21E",
        },
      ],
    },
    portfolio: "Portfolio",
    portfolioSubject: "Portfolio Request",
    portfolioBody:
      "Please let me know the purpose for which you are requesting my portfolio (e.g., hiring, project, freelance work, lecture, etc.).",
    coffee: "Coffee Chat",
    kotoro: "Kotoro",
    newsletter: "Newsletter",
    researchPapers: "Research Papers",
    patents: "Patents",
    awards: "Awards",
    title: "Title",
    author: "Author",
    year: "Year",
    note: "Note",
    papers: [
      {
        title:
          "Anti-VEGF treatment outcome prediction based on optical coherence tomography images in neovascular age-related macular degeneration using a deep neural network",
        author: "1st Author",
        year: "2024",
        note: "SCIE",
        url: "https://www.nature.com/articles/s41598-024-79034-6",
      },
      {
        title:
          "Prediction of Neovascular Age-related Macular Degeneration Recurrence using Optical Coherence Tomography Images with a Deep Neural Network",
        author: "2nd Author",
        year: "2024",
        note: "SCIE",
        url: "https://www.nature.com/articles/s41598-024-56309-6",
      },
      {
        title: "A Stemmer-based Korean Grapheme-to-Phoneme Converter for Speech Synthesis",
        author: "1st Author",
        year: "2023",
        note: "Best Paper",
        url: "https://www.dbpia.co.kr/journal/articleDetail?nodeId=NODE11567506",
      },
      {
        title:
          "Developing and Evaluating an Artificial Intelligence-Based Computer-Aided Diagnosis System for Retinal Disease",
        author: "2nd Author",
        year: "2023",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&citation_for_view=qt7vHIMAAAAJ:eQOLeE2rZwMC",
      },
      {
        title:
          "Developing and Evaluating an AI-Based Computer-Aided Diagnosis System for Retinal Disease: Diagnostic Study for Central Serous Chorioretinopathy",
        author: "2nd Author",
        year: "2023",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:YsMSGLbcyi4C",
      },
      {
        title:
          "Detecting Macular Disease Based on Optical Coherence Tomography Using a Deep Convolutional Network",
        author: "Author",
        year: "2023",
        note: "SCIE",
        url: "https://www.mdpi.com/2077-0383/12/3/1005",
      },
      {
        title:
          "Classifying neovascular age-related macular degeneration with a deep convolutional neural network based on optical coherence tomography images",
        author: "Author",
        year: "2022",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:Tyk-4Ss8FVUC",
      },
      {
        title:
          "Assessing central serous chorioretinopathy with deep learning and multiple optical coherence tomography images",
        author: "1st Author",
        year: "2022",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:zYLM7Y9cAGgC",
      },
      {
        title:
          "Classifying central serous chorioretinopathy subtypes with a deep neural network using optical coherence tomography images: a cross-sectional study",
        author: "2nd Author",
        year: "2022",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:qjMakFHDy7sC",
      },
      {
        title: "Trafficformer: A Transformer-based Traffic Predictor",
        author: "1st Author",
        year: "2022",
        note: "Conference",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:Y0pCki6q_DkC",
      },
      {
        title:
          "Distinguishing retinal angiomatous proliferation from polypoidal choroidal vasculopathy with a deep neural network based on optical coherence tomography",
        author: "2nd Author",
        year: "2021",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:u5HHmVD_uO8C",
      },
    ],
    patentsList: [
      {
        title:
          "3D Markerless Motion Capture-based 3D Avatar Generation Device and Method Patent Registration",
        number: "KR102438488B1",
        url: "https://patents.google.com/patent/KR102438488B1",
      },
      {
        title: "AI-based Hair Loss Management Device and Method Patent Registration",
        number: "KR102440397B1",
        url: "https://patents.google.com/patent/KR102440397B1",
      },
      {
        title:
          "Web Page Time-series Data Prediction Method, Device, Web Management System, Computer-readable Recording Medium and Computer Program Patent Registration",
        number: "KR20240011847A",
        url: "https://patents.google.com/patent/KR20240011847A/",
      },
      {
        title: "AI-based Retinal Disease Diagnosis Support Service System Patent Registration",
        number: "10-2024-0016551",
      },
      {
        title: "Speech Synthesis Device and Method Patent Application",
        number: "10-2023-0102961",
      },
    ],
    awardsList: [
      "2025 Korea Tourism Organization Prompthon Implementation Excellence Award",
      "2024 Wanted Lab x Naver Cloud Prompthon High Quality Award",
      "54th Korea Information and Communication Society Autumn Conference Best Paper Award (1st Author)",
      "Sungkyunkwan University AI Convergence Department Research Excellence Award (2022 Spring)",
      "Sungkyunkwan University AI Convergence Department Research Excellence Award (2022 Fall)",
      "Ministry of SMEs and Startups AI Championship Minister's Award (RaonData)",
      "Ministry of SMEs and Startups AI Championship Grand Championship (RaonData)",
      "Sungkyunkwan University 2022 Graduate Student Success Contest Selected",
    ],
  },
  zh: {
    name: "高俊瑞",
    nickname: "Chato Ko",
    role: "机器学习工程师",
    team: "Heydealer",
    email: "商务咨询:",
    companies: {
      names: ["Heydealer (PRND Company)", "Gangnam Unni Team", "RaonData"],
      years: ["2025.04 ~ 현재", "2024.09 ~ 2025.04", "2021.09 ~ 2024.09"],
    },
    educationLabel: "教育",
    aboutLabel: "关于",
    careerLabel: "工作",
    education: "成均馆大学人工智能融合学科 学士/硕士",
    introduction: "您好，我是一名有4年经验的机器学习/人工智能工程师。",
    workDescription:
      "我在Heydealer (PRND Company) 工作。我也在开发和运营新闻通讯和kotoro服务。我也在进行外部讲座和解决方案。请通过以下电子邮件联系我。",
    github: "GitHub",
    scholar: "Google Scholar",
    youtube: "YouTube",
    linkedin: "LinkedIn",
    blog: "Blog",
    book: "Lecture Notes",
    techLabel: "技术:",
    lectures: "外部讲座",
    projects: "代表项目",
    lectureName1: "[TeddyNote] Prompt竞赛冠军策略介绍",
    lectureName2: "[Vessl AI] 成本节约型LLMOps改进经验",
    lectureName3: "[成均馆大学] 机器学习概论特讲",
    project1: {
      title: "GangnamUnni团队ML平台构建",
      description:
        "通过构建特征存储、模型性能监控、自动部署引擎、模型日志监控系统等，建立了机器学习各组件有机连接的平台。",
      tech: "使用Python、Kubernetes、Airflow、FastAPI构建ML平台",
    },
    project2: {
      title: "语音合成模型研究与开发",
      description:
        "研究开发语音合成模型，通过韩语发音算法开发提高语音合成质量。已成功应用于Cartiers、SBS Medianet、TV朝鲜、Galaxy Corporation等多家企业。",
      tech: "使用PyTorch、VITS、KiwiTokenizer开发语音合成模型",
    },
    project3: {
      title: "医疗图像人工智能研究与开发",
      description:
        "进行医疗图像人工智能研究与开发。使用SD-OCT图像开发视网膜疾病预测模型，发表9篇SCIE级期刊论文，并向Hangil眼科医院提供解决方案。",
      tech: "使用PyTorch和计算机视觉进行医学图像分析",
    },
    project4: {
      title: "LLM/RAG研究与开发",
      description:
        "进行LLM/RAG研究与开发。开发了整形协调员服务和方言语言模型JEJUMA，在Wanted x Naver Cloud Prompthon比赛中获得第一名。",
      tech: "使用LLM、RAG、LangChain开发人工智能聊天机器人",
      techLabel: "技术:",
      links: [
        {
          title: "开发的项目",
          url: "https://cosmetic.kojunseo.link/",
          iconType: "check",
          iconColor: "#20C997",
        },
        {
          title: "相关新闻",
          url: "https://m.ddaily.co.kr/page/view/2024073016092806180",
          iconType: "news",
          iconColor: "#718096",
        },
        {
          title: "Jejuma",
          url: "https://huggingface.co/JEJUMA/JEJUMA-002",
          iconType: "huggingface",
          iconColor: "#FFD21E",
        },
      ],
    },
    portfolio: "Portfolio",
    portfolioSubject: "作品集请求",
    portfolioBody: "请告诉我您请求我的作品集的目的（例如：招聘、项目、外包工作、讲座等）。",
    coffee: "喝咖啡聊聊天",
    kotoro: "Kotoro",
    newsletter: "新闻通讯",
    researchPapers: "研究论文",
    patents: "专利",
    awards: "获奖经历",
    title: "标题",
    author: "作者",
    year: "年份",
    note: "备注",
    papers: [
      {
        title:
          "Anti-VEGF treatment outcome prediction based on optical coherence tomography images in neovascular age-related macular degeneration using a deep neural network",
        author: "第一作者",
        year: "2024",
        note: "SCIE",
        url: "https://www.nature.com/articles/s41598-024-79034-6",
      },
      {
        title:
          "Prediction of Neovascular Age-related Macular Degeneration Recurrence using Optical Coherence Tomography Images with a Deep Neural Network",
        author: "第二作者",
        year: "2024",
        note: "SCIE",
        url: "https://www.nature.com/articles/s41598-024-56309-6",
      },
      {
        title: "A Stemmer-based Korean Grapheme-to-Phoneme Converter for Speech Synthesis",
        author: "第一作者",
        year: "2023",
        note: "优秀论文奖",
        url: "https://www.dbpia.co.kr/journal/articleDetail?nodeId=NODE11567506",
      },
      {
        title:
          "Developing and Evaluating an Artificial Intelligence-Based Computer-Aided Diagnosis System for Retinal Disease",
        author: "第二作者",
        year: "2023",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&citation_for_view=qt7vHIMAAAAJ:eQOLeE2rZwMC",
      },
      {
        title:
          "Developing and Evaluating an AI-Based Computer-Aided Diagnosis System for Retinal Disease: Diagnostic Study for Central Serous Chorioretinopathy",
        author: "第二作者",
        year: "2023",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:YsMSGLbcyi4C",
      },
      {
        title:
          "Detecting Macular Disease Based on Optical Coherence Tomography Using a Deep Convolutional Network",
        author: "作者",
        year: "2023",
        note: "SCIE",
        url: "https://www.mdpi.com/2077-0383/12/3/1005",
      },
      {
        title:
          "Classifying neovascular age-related macular degeneration with a deep convolutional neural network based on optical coherence tomography images",
        author: "作者",
        year: "2022",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:Tyk-4Ss8FVUC",
      },
      {
        title:
          "Assessing central serous chorioretinopathy with deep learning and multiple optical coherence tomography images",
        author: "第一作者",
        year: "2022",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:zYLM7Y9cAGgC",
      },
      {
        title:
          "Classifying central serous chorioretinopathy subtypes with a deep neural network using optical coherence tomography images: a cross-sectional study",
        author: "第二作者",
        year: "2022",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:qjMakFHDy7sC",
      },
      {
        title: "Trafficformer: A Transformer-based Traffic Predictor",
        author: "第一作者",
        year: "2022",
        note: "Conference",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:Y0pCki6q_DkC",
      },
      {
        title:
          "Distinguishing retinal angiomatous proliferation from polypoidal choroidal vasculopathy with a deep neural network based on optical coherence tomography",
        author: "第二作者",
        year: "2021",
        note: "SCIE",
        url: "https://scholar.google.com/citations?view_op=view_citation&hl=ko&user=qt7vHIMAAAAJ&sortby=pubdate&citation_for_view=qt7vHIMAAAAJ:u5HHmVD_uO8C",
      },
    ],
    patentsList: [
      {
        title: "基于3D无标记运动捕捉的3D头像生成设备和方法专利注册",
        number: "KR102438488B1",
        url: "https://patents.google.com/patent/KR102438488B1",
      },
      {
        title: "基于人工智能的脱发管理设备和方法专利注册",
        number: "KR102440397B1",
        url: "https://patents.google.com/patent/KR102440397B1",
      },
      {
        title:
          "网页时间序列数据预测方法、设备、网页管理系统、计算机可读记录介质及计算机程序专利注册",
        number: "KR20240011847A",
        url: "https://patents.google.com/patent/KR20240011847A/",
      },
      {
        title: "基于AI的视网膜疾病诊断辅助服务系统专利注册",
        number: "10-2024-0016551",
      },
      {
        title: "语音合成设备和方法专利申请",
        number: "10-2023-0102961",
      },
    ],
    awardsList: [
      "2025年韩国观光公社Prompthon实现优秀奖",
      "2024年Wanted Lab x Naver Cloud Prompthon高品质奖",
      "第54届韩国信息通信学会秋季学术大会优秀论文奖（第一作者）",
      "成均馆大学人工智能融合学科研究优秀奖（2022年春季学期）",
      "成均馆大学人工智能融合学科研究优秀奖（2022年秋季学期）",
      "中小风险企业事业部人工智能锦标赛部长奖（RaonData）",
      "中小风险企业事业部人工智能锦标赛总冠军赛（RaonData）",
      "成均馆大学2022年研究生学生成功公募展入选",
    ],
  },
};
